<app-module-header [title]="organization.organizationName + ' - ' + ('KEY_TASKS.TITLE' | transloco)"
[icon]="'task'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<div class="">
  <mat-tab-group syncTabsWithUrl>
    @if (organization?.config?.handleAdditionalServices) {
      <mat-tab label="Planning" urlKey="planning">
        <app-additional-service-planning (incrementRequests)="incrementRequests()"
        (decrementRequests)="decrementRequests()"></app-additional-service-planning>
      </mat-tab>
    }

    @if (organization?.config?.handleAdditionalServices) {
      <mat-tab label="Driver View" urlKey="driver">
        <div class="colheader">
          <mat-icon class="icon-bottom me-1">task</mat-icon>
          {{ 'KEY_TASKS.DRIVER_TASKS_HEADER' | transloco }} {{driverDataSource.data.length}}
        </div>
        <!-- <div class="no-data-message" *ngIf="driverDataSource.data.length === 0">
        {{ 'KEY_TASKS.NO_DRIVER_TASKS' | transloco }}
      </div> -->
      <div class="overflow-auto">
        <table mat-table [dataSource]="driverDataSource.data.length > 0 ? driverDataSource : emptyData"
          class="mat-elevation-z8">
          <!-- Order Task ID Column -->
          <ng-container matColumnDef="orderLockerId">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.TASK_ID' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.orderLockerId}}</td>
          </ng-container>
          <!-- Sharebox ID Column -->
          <ng-container matColumnDef="shareboxId">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SHAREBOX_ID' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.lockerId ? 'Yes' :
            'No'}}</td>
          </ng-container>
          <!-- Order ID Column -->
          <ng-container matColumnDef="orderNr">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.ORDER_ID' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.orderNr}}</td>
          </ng-container>
          <!-- Car ID Column -->
          <ng-container matColumnDef="carId">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.VEHICLE_REGISTRATION' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.carId}}</td>
          </ng-container>
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.STATUS' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">
              <app-status-badge [text]="getStatusData('status', element.status).text | transloco"
                [color]="getStatusData('status', element.status).color" [isPayment]="false" [isBooking]="false">
              </app-status-badge>
            </td>
          </ng-container>
          <!-- Safe Name Column -->
          <ng-container matColumnDef="safeName">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_NAME' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.safeName}}</td>
          </ng-container>
          <!-- Safe Hook No Column -->
          <ng-container matColumnDef="safeHookNo">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_HOOK_NO' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.safeHookNo}}</td>
          </ng-container>
          <!-- Safe Hook Status Column -->
          <ng-container matColumnDef="safeHookStatus">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_HOOK_STATUS' | transloco }}</th>
            <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">
              <app-status-badge [text]="getStatusData('safeHook', element.safeHookStatus).text | transloco"
                [color]="getStatusData('safeHook', element.safeHookStatus).color" [isPayment]="false"
                [isBooking]="false">
              </app-status-badge>
            </td>
          </ng-container>
          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.TYPE' | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              <!-- <app-status-badge
              [text]="getStatusData('type', element.type).text | transloco"
              [color]="getStatusData('type', element.type).color"
              [isPayment]="false"
              [isBooking]="false">
            </app-status-badge> -->
            @if (element.type === 1 && !element.connectedUserEmail && !element.connectedUserId) {
              <button mat-flat-button color="primary" (click)="completeTask(element.orderLockerId, 'key-driver')">
                {{ getStatusData('type', 3).text | transloco }}
                <!-- {{ 'KEY_TASKS.COMPLETE_TASK' | transloco }} -->
              </button>
            } @else {
              <button mat-flat-button color="primary" (click)="completeTask(element.orderLockerId, 'driver')">
                {{ getStatusData('type', element.type).text | transloco }}
                <!-- {{ 'KEY_TASKS.COMPLETE_TASK' | transloco }} -->
              </button>
            }
          </td>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.ACTIONS' | transloco }}</th>
          <td mat-cell *matCellDef="let element">
            <button mat-flat-button color="primary" (click)="completeTask(element.orderLockerId, 'driver')">
              {{ 'KEY_TASKS.COMPLETE_TASK' | transloco }}
            </button>
          </td>
        </ng-container>
        <!-- User Column -->
        <ng-container matColumnDef="connectedUserEmail">
          <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.USER' | transloco }}</th>
          <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.connectedUserEmail}}
          </td>
        </ng-container>
        <ng-container matColumnDef="empty-row">
          <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
          *matRowDef="let row; columns: driverDataSource.data.length > 0 ? displayedColumns : ['empty-row'];"
        class="clickable"></tr>
      </table>
    </div>
  </mat-tab>
}

<!-- <mat-tab label="Additional Services"> -->
<!-- <div class="col" *ngIf="!isLoading">
<div class="col1">
  <div class="colheader">
    <mat-icon class="icon-bottom me-1">task</mat-icon>
    {{ 'KEY_TASKS.ADMIN_TASKS_HEADER' | transloco }} {{adminDataSource.data.length}}
  </div>
  <div class="no-data-message" *ngIf="adminDataSource.data.length === 0">
    {{ 'KEY_TASKS.NO_ADMIN_TASKS' | transloco }}
  </div>
  <table mat-table [dataSource]="adminDataSource" class="mat-elevation-z8"
    *ngIf="adminDataSource.data.length > 0">

    <ng-container matColumnDef="orderTaskId">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.ORDER_TASK_ID' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.orderTaskId}}</td>
    </ng-container>

    <ng-container matColumnDef="shareboxId">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SHAREBOX_ID' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.shareboxId ? 'Yes' :
      'No'}}</td>
    </ng-container>

    <ng-container matColumnDef="orderId">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.ORDER_ID' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.orderId}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.STATUS' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">
        <app-status-badge [text]="getStatusData('status', element.status).text | transloco"
          [color]="getStatusData('status', element.status).color" [isPayment]="false" [isBooking]="false">
        </app-status-badge>
      </td>
    </ng-container>

    <ng-container matColumnDef="safeHookName">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_HOOK_NAME' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.safeHookName}}</td>
    </ng-container>

    <ng-container matColumnDef="safeHookNo">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_HOOK_NO' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">{{element.safeHookNo}}</td>
    </ng-container>

    <ng-container matColumnDef="safeHookStatus">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.SAFE_HOOK_STATUS' | transloco }}</th>
      <td mat-cell *matCellDef="let element" (click)="goToOrder(element.orderId)">
        <app-status-badge [text]="getStatusData('safeHook', element.safeHookStatus).text"
          [color]="getStatusData('safeHook', element.safeHookStatus).color" [isPayment]="false"
          [isBooking]="false">
        </app-status-badge>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.TYPE' | transloco }}</th>
      <td mat-cell *matCellDef="let element"> -->
        <!-- <app-status-badge
        [text]="getStatusData('type', element.type).text | transloco"
        [color]="getStatusData('type', element.type).color"
        [isPayment]="false"
        [isBooking]="false">
      </app-status-badge> -->
      <!-- <button mat-flat-button color="primary" (click)="completeTask(element.orderTaskId, 'admin')">
      {{getStatusData('type', element.type).text | transloco}}
      {{ 'KEY_TASKS.COMPLETE_TASK' | transloco }}
    </button>
  </td>
</ng-container>

<ng-container matColumnDef="actions">
  <th mat-header-cell *matHeaderCellDef>{{ 'KEY_TASKS.ACTIONS' | transloco }}</th>
  <td mat-cell *matCellDef="let element">
    <button mat-flat-button color="primary" (click)="completeTask(element.orderLockerId, 'admin')">
      {{ 'KEY_TASKS.COMPLETE_TASK' | transloco }}
    </button>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns;">
</tr>
</table>
</div>
</div> -->
<!-- </mat-tab> -->

@if (organization?.config?.handleFlights) {
  <mat-tab [label]="'FLIGHT.PROBLEM_FLIGHTS' | transloco"
    urlKey="flights">
    <app-problem-flights-list></app-problem-flights-list>
  </mat-tab>
}

@if (organization?.config?.handleAdditionalServices) {
  <mat-tab [label]="'Unplanned Tasks'" urlKey="unplanned">
    <app-additional-service-tasks [organization]="organization" [selectedStatuses]="[1, 2]"
      [initialSortedColumn]="'from'" [initialSortDirection]="'asc'" (incrementRequests)="incrementRequests()"
    (decrementRequests)="decrementRequests()" [isLoading]="isLoading"></app-additional-service-tasks>
  </mat-tab>
}

@if (organization?.config?.handleAdditionalServices) {
  <mat-tab [label]="'Planned Tasks'" urlKey="planned">
    <app-additional-service-tasks [organization]="organization" [selectedStatuses]="[4]"
      [initialSortedColumn]="'from'" [initialSortDirection]="'asc'" (incrementRequests)="incrementRequests()"
    (decrementRequests)="decrementRequests()" [isLoading]="isLoading"></app-additional-service-tasks>
  </mat-tab>
}

@if (organization.organizationId?.toLowerCase() === '942ce067-7848-4441-b746-8f6eed7395bb') {
  <mat-tab
    label="Unordered Parkings" urlKey="unordered">
    @if (!isLoading) {
      <div class="col">
        <div class="col1">
          <div class="colheader">
            <mat-icon class="icon-bottom me-1">local_parking</mat-icon>
            Unordered Parkings {{unorderedParkingsDataSource.data.length}}
          </div>
          @if (unorderedParkingsDataSource.data.length === 0) {
            <div class="no-data-message">
              No unordered parkings found
            </div>
          }
          @if (unorderedParkingsDataSource.data.length > 0) {
            <table mat-table [dataSource]="unorderedParkingsDataSource" class="mat-elevation-z8"
              >
              <ng-container matColumnDef="licensePlate">
                <th mat-header-cell *matHeaderCellDef>License Plate</th>
                <td mat-cell *matCellDef="let element">{{element.licensePlate}}</td>
              </ng-container>
              <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef>Created</th>
                <td mat-cell *matCellDef="let element">{{element.created | date:'yyyy-MM-dd'}} {{ 'PARKIFLY.CLOCK_SHORT' |
                transloco }} {{element.created | date:'HH:mm'}}</td>
              </ng-container>
              <ng-container matColumnDef="parkingPeriod">
                <th mat-header-cell *matHeaderCellDef>Parking Period</th>
                <td mat-cell *matCellDef="let element">{{element.parkingPeriod}}</td>
              </ng-container>
              <ng-container matColumnDef="isOrderCreated">
                <th mat-header-cell *matHeaderCellDef>Order Created</th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon [style.color]="element.isOrderCreated ? 'green' : 'red'">
                    {{element.isOrderCreated ? 'check_circle' : 'cancel'}}
                  </mat-icon>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="unorderedParkingsColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: unorderedParkingsColumns;" class="clickable"
              (click)="onRowClick(row)"></tr>
            </table>
          }
        </div>
      </div>
    }
  </mat-tab>
}

<!-- <mat-tab *ngIf="organization?.config?.handleAdditionalServices" label="Planning">
<app-additional-service-planning (incrementRequests)="incrementRequests()" (decrementRequests)="decrementRequests()"></app-additional-service-planning>
</mat-tab> -->
</mat-tab-group>
</div>